<template>
    <section class="maps light purple">
        <div class="location-list">
            <h2>Onze locaties</h2>
            <div :class="{ 'accordeon': true, 'is-open': open !== null }">
                <div v-for="( location, index ) in locations" :key="index">
                    <div class="location-label" v-if="open === null || open === index" :class="{ 'isOpen': open === index }" @click="toggleOpen( index )">
                        <span>{{ location.street }}</span>
                        <div class="open-close-icon"></div>
                    </div>

                    <div class="info" v-if="open === index">
                        <p>{{ location.zipcode }}</p>

                        <div v-for="school in location.schools">
                            <h3>{{ school.name }}</h3>

                            <p v-if="school.text">{{ school.text }}</p>
                            <ul v-if="school.courseList">
                                <li v-for="course in school.courseList">{{ course }}</li>
                            </ul>
                            <a v-if="school.website" target="_blank" :href="'https://' + school.website" >{{ school.website }}</a>
                            <a v-if="school.telephone" target="_blank" :href="'tel:' + school.telephone" >{{ school.telephone }}</a>
                            <a v-if="school.email" target="_blank" :href="'mailto:' + school.email" >{{ school.email }}</a>

                            <!-- <p v-if="school.extra">{{ school.extra }}</p> -->
                        </div>
                    </div>
                </div>
            </div>
            <p v-if="open === null">Ook werken wij samen met het bedrijfsleven en andere onderwijsinstellingen op de volgende locaties: MindLabs en Loft in Tilburg en Gate 2 in Rijen.</p>
        </div>
        <div class="map-wrapper">
            <!-- <img src="http://placehold.it/1000x1000" /> -->
            <div id="map" ref="map"></div>
            <div class="map">

            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>

</style>

<script>
    import locationData from '@/app/data/locationData';

    export default {
        name: 'OntwikkelingMaps',
        meta: {
            title: 'OntwikkelingMaps',
            color: '#a5147e'
        },

        components: {
        },

        data()
        {
            return {
                locations: locationData,

                open: null
            };
        },

        mounted()
        {
            this.currentOpenWindow = null;

            this.map = new window.google.maps.Map( this.$refs.map, {
                zoom: 12.5,
                center: {
                    lat: 51.5484456,
                    lng: 5.0629701
                }
            });

            for( let i = 0; i < this.locations.length; i++ )
            {
                let location = this.locations[i];

                if( location.lat && location.lng )
                {
                    // place marker
                    let iconImage = {
                        url: '/static/img/maps-marker.svg',
                        // This marker is 20 pixels wide by 32 pixels high
                        scaledSize: new window.google.maps.Size( 32, 32 ),
                        // The origin for this image is (0, 0).
                        origin: new window.google.maps.Point( 0, 0 ),
                        // The anchor for this image is the base of the flagpole at (0, 32).
                        anchor: new window.google.maps.Point( 16, 16 )
                    };

                    /* eslint-disable-next-line */
                    let marker = new window.google.maps.Marker({
                        position: {
                            lat: parseFloat( location.lat ),
                            lng: parseFloat( location.lng )
                        },
                        map: this.map,
                        title: 'Test title',
                        icon: iconImage
                    });

                    let infowindow = new window.google.maps.InfoWindow({
                        content: this.getInfoWindow( location )
                    });

                    marker.addListener( 'click', () =>
                    {
                        this.toggleOpen( i );
                    });

                    location.marker = marker;
                    location.infowindow = infowindow;
                }
            }
        },

        methods: {
            getInfoWindow( location )
            {
                let content = `
                    <div class="google-maps-info-window">
                        <img src="${location.schools[0].image}" />
                    </div>
                `;

                return content;
            },

            getIconMarkerURL( location )
            {
                let imageURL = '/static/img/googlemaps/icon-blue.png';

                if( location.TinTing )
                {
                    imageURL = '/static/img/googlemaps/icon-grey.png';
                }
                if( location.Service )
                {
                    imageURL = '/static/img/googlemaps/icon-orange.png';
                }
                return imageURL;
            },

            toggleOpen( pIndex )
            {
                if( this.open === pIndex )
                {
                    // als er al een open is met dezelfde index, sluit hem
                    this.open = null;
                    this.currentOpenWindow.close();
                    this.locations[pIndex].infowindow.close();

                    return;
                }

                // altijd maar 1 open forceren
                if( this.currentOpenWindow )
                {
                    this.currentOpenWindow.close();
                }

                // maak nieuwe window
                this.locations[pIndex].infowindow.open( this.map, this.locations[pIndex].marker );
                this.currentOpenWindow = this.locations[pIndex].infowindow;

                this.open = pIndex;
            },

            focus()
            {
            }

        }
    };
</script>
